import request from '@/utils/request'

export default {
  login(parameter) {
    return request({
      url: 'v1/ally/login',
      method: 'post',
      data: parameter
    })
  },

  // 医院列表
  hoslist(parameter) {
    return request({
      url: 'v1/ally/list',
      method: 'get',
      params: parameter
    })
  },

  // 检验报告列表
  sample(parameter) {
    return request({
        url: 'v1/sample/samples',
        method: 'get',
        params: parameter
      })
  },

  // 生成excel文档
  genExcel(parameter) {
    return request({
        url: 'v1/sample/genExcel',
        method: 'post',
        params: parameter,
        responseType: 'blob',
      })
  },
  
  // 确认打印
  handlePrint(parameter) {
    return request({
        url: 'v1/sample/handlePrint',
        method: 'post',
        data: parameter
      })
  },

   // 确认打印
   handlePrintCode(parameter) {
    return request({
        url: 'v1/sample/handlePrintCode',
        method: 'post',
        data: parameter
      })
  },

   // 确认打印
   sampleImage(id) {
    return request({
        url: 'v1/sample/sampleImage/' + id,
        method: 'get',
        responseType: 'blob',
        headers:{ 'Content-Type': 'application/json; application/octet-stream'},
      })
  },
   
  // 合并pdf
  batchPrint(parameter) {
    return request({
        url: 'v1/sample/batchPrint',
        method: 'get',
        params: parameter,
        responseType: 'blob',
      })
  },
  
  // 公告列表
  noticeList(parameter) {
    return request({
        url: 'v1/notice/list',
        method: 'get',
        params: parameter
      })
  },
   
  // 公告详情
  noticeInfo(parameter) {
    return request({
        url: 'v1/notice/info',
        method: 'get',
        params: parameter
      })
  },
  
}
